import { LinearProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import React, { Suspense } from 'react';
import { renderRoutes } from 'react-router-config';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
  },
}));

const Error = props => {
  const { route } = props;

  const classes = useStyles();

  return (
    <main className={classes.root}>
      <Suspense fallback={<LinearProgress/>}>
        {renderRoutes(route.routes)}
      </Suspense>
    </main>
  );
};

Error.propTypes = {
  route: PropTypes.object,
};

export default Error;
